<template>
    <div class="container-fluid mt--6">
        <div class="row xsOnly">
            <div class="col-xl-12">
            <div class="card scrollbar vh-75" id="scroll">
                <div class="table-responsive"> 
                    <h4 class="d-inline-block mt-1 py-4">Price Changed Offers
                  
                </h4>
                <!-- Table Search -->
                  <div class="input-group col-md-2 tbl-sch" style="top:23px">
                    <button :disabled="offers.length == 0" type="button"  class="btn btn-primary"  @click="offerReupload()">
                        REUPLOAD
                    </button>
                    <button :disabled="offers.length == 0" type="button"  class="btn btn-warning"  @click="offerCancel()">
                        CANCEL
                    </button>
                  </div>                   
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl">
                        <thead class="thead-light psticky">
                        <tr >
                            <th 
                                scope="col" 
                                class="sort"
                                >
                                <span><input class="form-check-input" @change="selecteAll()" type="checkbox" v-model="isSelectedAll"></span></th>
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                                @click="sort('cusip')">CUSIP</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                                @click="sort('quantity')">QTY</th>
                                <th
                                scope="col"
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                                @click="sort('quantity')">Fill/Rem
                                </th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                                @click="sort('price')">PRICE</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                                @click="sort('offerValidity')">UPDATED PRICE</th>
                                <!-- <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                                @click="sort('offerType')">OFFER <br>  TYPE</th> -->
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                                @click="sort('coupon')">COUPON</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                                @click="sort('cost')">COST</th>
                                <th
                                scope="col"
                                class="sort text-left">TMC<br>Price
                                </th>
                                <th
                                scope="col"
                                class="sort text-left">TWR<br>Price
                                </th>
                                <th
                                scope="col"
                                class="sort text-left">KBP<br>Price
                                </th>
                                <th
                                scope="col"
                                class="sort text-left">MKTX<br>Price
                                </th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                                @click="sort('yield')">YIELD</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                                @click="sort('yieldSpread')">SPREAD</th>
                            </tr>
                        </thead>  
                        <tbody class="">
                            <tr >
                                <td v-if="offers.length == 0 && !loader" colspan="5"><p class="nodata n">No data available</p>
                                </td>
                                <td v-if="loader">
                                    <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                </td>
                            </tr>
                            <tr v-for="offer in offers" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive}">
                                <td class="text-center">
                                    <span><input class="form-check-input" type="checkbox"  v-model="offer.isUpload"></span><br>
                                </td>
                                <td>
                                    <span class="cusips">{{offer.cusipVal}}</span>
                                </td>
                                <td class="text-center">
                                    <span>{{offer.quantity}}</span><br>
                                </td>
                                <td class="text-center">
                                    <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                                    <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                                </td>
                                <td class="text-center">
                                    <span>{{offer.price ? offer.price.toFixed(3) : 0 }}   </span><br>
                                </td>
                                <td class="text-center">
                                    <span style="color:red">{{offer.updatedPriceByYeild}}</span><br>
                                </td>
                                <!-- <td class="text-center">
                                    <span>{{offer.offerType}}</span><br>
                                </td> -->
                                <td class="text-center">
                                    <span>{{offer.coupon |  percent(3)}}</span><br>
                                </td>
                                <td class="text-center">
                                    <span>{{offer.cost ? offer.cost.toFixed(3) : 0}}</span><br>
                                </td>
                                <td class="text-left">
                                    <!-- <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.tmcStatus).message" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{offer.tmcStatus}}</span> -->
                                    <span class="text-primary">{{offer.tmcprice ? offer.tmcprice.toFixed(3) : 0}}</span>
                                </td>
                                <td class="text-left">
                                    <!-- <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.twdStatus).message" v-bind:class="getEcnStatus(offer.twdStatus).className">{{offer.twdStatus}}</span> -->
                                    <span class="text-primary">{{offer.twdprice ? offer.twdprice.toFixed(3) : 0}}</span>
                                </td>
                                <td class="text-left">
                                    <!-- <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.ibpStatus).message"  v-bind:class="getEcnStatus(offer.ibpStatus).className">{{offer.ibpStatus}}</span> -->
                                    <span class="text-primary">{{offer.ibpprice ? offer.ibpprice.toFixed(3) : 0}}</span>
                                </td>
                                <td class="text-left">
                                    <!-- <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message"  v-bind:class="getEcnStatus(offer.ibpStatus).className">{{offer.ibpStatus}}</span> -->
                                    <span class="text-primary">{{offer.mktxPrice ? offer.mktxPrice.toFixed(3) : 0}}</span>
                                </td>
                                
                                <td class="text-center">
                                    <span>{{offer.yield}}</span>
                                </td>
                                <td class="text-center">
                                    <span>{{(offer.price - offer.cost).toFixed(3)}}</span>
                                </td>
                                </tr>                 
                        </tbody>
                    </table> 
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getOffer(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                </div>  
            </div>
            </div>  
        </div>
    </div>            
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import ecnStatus from "@/ecnStatus";

export default {
    name: 'OfferPriceChange',
    data() {
        return {
            cognitoSub : null,
            offers:[],
            loader : false,
            currentPage: 1,
            perPage: 20,
            searchValue : "",
            totalRows : 0,
            sortColumn: "latestDate",
            sortOrder: "DESC",
            ecnStatus : ecnStatus,
            isSelectedAll : false

        };
    },
    methods : {
    selecteAll(){
        console.log(this.isSelectedAll);
        var self = this;
        this.offers.forEach(function(offer) {
            offer.isUpload = self.isSelectedAll;
        });
    },
    getOfferDetails(offerSelected){
      this.offers.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getEcnStatus(ecnStatus){
      //console.log(this.ecnStatus)
      var ecnData = this.ecnStatus.find(x => x.status === ecnStatus);
      if(ecnData){
        var className = ecnData.type == 'error'  ? 'border-warning text-error' : 'border-success text-success';
        return  { className : className ,status : ecnStatus,message : ecnData.message }
      }else{
        return  { className : 'border-success text-success' ,status : ecnStatus, message : "" }
      }
      
    },
    getOffer(currentPage){
        this.loader = true;
        if (!currentPage) {
            currentPage = 1;
        }
         const auth = {
            headers: {'org-token' : authService.getOrgToken() }
         };
         this.$http
         .get(
            config.baseUrlBidSide +
            "/offer/listall?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=PRICE_CHANGE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&cognitoSub="+
            "&cusips="+
            "&accountMappingIds=",
            auth
         )
         .then(result => {
            //console.log(result) 
            this.offers = result.data.content;
            this.totalRows = result.data.pageInfo.totalElements;

            this.loader = false;
         })
         .catch(() => {
            this.loader = false;
        });
    },
    offerReupload(){
      var selectedOffer = 0;
      this.offers.forEach((offer) => {
            offer.isUpload ? selectedOffer++ : "";
      }); 
      if(!selectedOffer){
          this.$alert("Please select at least one offer","" , "error");
          return false
      }
      let dataToSend = {
            "offersToUpload" : [],
            "offerIdsToRemove":[],
            "uploadDailyAll":false,
            "uploadPriceChangeAll":false,
            "userId" : authService.getUser().id
        }
      var message = "Selected offers will be reuploaded";
      this.$confirm(message,"CONFIRM","",{confirmButtonText:"Upload",cancelButtonText : "No"}).then(() => {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.offers.forEach((offer) => {
            dataToSend.offersToUpload.push({offerId : offer.id ,upload : offer.isUpload ? true : false });
        });
          this.$http
          .put(config.baseUrlBidSide + "/offer/reupload-daily",dataToSend,auth)
          .then(() => {
            this.loading = false;
            this.getOffer();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
    offerCancel(){
      var selectedOffer = 0;
      this.offers.forEach((offer) => {
            offer.isUpload ? selectedOffer++ : "";
      }); 
      if(!selectedOffer){
          this.$alert("Please select at least one offer","" , "error");
          return false
      }
      let dataToSend = {
            "offersToUpload" : [],
            "offerIdsToRemove":[],
            "uploadDailyAll":false,
            "uploadPriceChangeAll":false,
            "userId" : authService.getUser().id
        }
      var message = "Selected offers will be cancel";
      this.$confirm(message,"CONFIRM","",{confirmButtonText:"Cancel",cancelButtonText : "No"}).then(() => {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.offers.forEach((offer) => {
            dataToSend.offerIdsToRemove.push(offer.id);
        });
          this.$http
          .put(config.baseUrlBidSide + "/offer/reupload-daily",dataToSend,auth)
          .then(() => {
            this.loading = false;
            this.getOffer();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     }
  },
  created(){ 
    this.cognitoSub = authService.getUser().cognitoSub;
    this.getOffer();
  }
};
</script>